export const MIN_ALERT_COUNT = 32;
export const LOCK_CLAIM_COUNT = 43;
